import { classes, style } from 'typestyle';
import * as React from 'react';
import { Component, deps, inject, observer } from '../../../lib/component';
import { PrismicTypedDashboardHeaderProps } from '../utilities/types';
import crown from '../../../static/crown.svg';

import { percent, px, rem, url } from 'csx';
import { mediaDesktop, mediaUpToDesktop } from '../utilities/mediaQueries';
import { colorWhite, rebrand } from '../../../theme/color';

import { flexRoot } from 'csstips';

import { RatecardDisplay } from '../molecules/RatecardDisplay';
import { DashboardHeaderCarousel } from './DashboardHeaderCarousel';
import { CommonDesktopBreakpoint } from '../config';
import { debounce } from '../utilities/functions';

const styles = {
  container: style({
    background: rebrand.contrast[70].toHexString(),
    $nest: {
      '& + *:not(.slice-group)': {
        marginTop: '56px',
      },
    },
  }),
  wrapper: style(
    mediaDesktop({
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      maxWidth: px(CommonDesktopBreakpoint),
      margin: '0 auto',
      height: '100%',
    })
  ),
  welcome: style(
    {
      maxWidth: '500px',
      padding: '16px 0',
    },
    mediaDesktop({
      padding: '34px 16px 16px',
    })
  ),
  welcomeHeading: style(
    {
      position: 'relative',
      zIndex: 1,
      margin: 0,
      textAlign: 'center',
      color: colorWhite.toString(),
      $nest: {
        '& span': {
          display: 'block',
        },
      },
    },
    mediaUpToDesktop({
      fontSize: rem(2.5), // 40px
    }),
    mediaDesktop({
      fontSize: rem(3.5),
      textAlign: 'left',
      overflow: 'visible',
      // Crown background image - using a pseudo element to make overflow visible
      $nest: {
        '&::before': {
          content: "''",
          width: px(162),
          height: px(144),
          backgroundImage: url(crown),
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          top: px(-37),
          right: px(-61),
          zIndex: -1,
        },
      },
    })
  ),
  textWrapper: style({
    $nest: {
      '& span': {
        display: 'block',
      },
    },
  }),
  headingRatecardWrapper: style(
    {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '16px',
    },
    mediaDesktop({
      padding: '32px',
      justifyContent: 'flex-start',
    })
  ),
  allWidth: style(flexRoot, {
    width: percent(100),
  }),
};

// Styles for NO PROMO version of the component
const noPromoStyles = {
  container: style(
    {
      position: 'relative',
    },
    // No promo container has a darker background on the left from desktop up
    mediaDesktop({
      $nest: {
        '&::before': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '50%',
          backgroundColor: rebrand.contrast[90].toHexString(),
        },
      },
    })
  ),
  wrapper: style({
    alignItems: 'center',
  }),
  welcome: style(
    {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    mediaUpToDesktop({
      padding: '32px 16px 16px',
    })
  ),
  headingRatecardWrapper: style(
    mediaDesktop({
      justifyContent: 'center',
    })
  ),
};

const WelcomeToDashboard = ({ className }: { className?: string }) => (
  <div className={classes(styles.welcome, className)}>
    <h1 className={styles.welcomeHeading}>
      Welcome to <span>your dashboard</span>
    </h1>
  </div>
);

export type Props = { items: PrismicTypedDashboardHeaderProps[] };

@inject(deps)
@observer
export class DashboardHeader extends Component<Props> {
  state = {
    page: 1,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      items,
      model: {
        user: { user },
      },
      controller: {
        analytics: { sendMixpanel },
      },
    } = this.props;
    const defaultChannel = user && user.default_channel;
    const promoExist = items.length > 0;

    return (
      <div className={classes(styles.container, !promoExist && noPromoStyles.container)}>
        <div className={classes(styles.wrapper, !promoExist && noPromoStyles.wrapper)}>
          {promoExist ? (
            <DashboardHeaderCarousel items={items} sendMixpanel={sendMixpanel} />
          ) : (
            <WelcomeToDashboard className={noPromoStyles.welcome} />
          )}
          <div className={classes(styles.headingRatecardWrapper, !promoExist && noPromoStyles.headingRatecardWrapper)}>
            {promoExist && <WelcomeToDashboard />}
            <div className={styles.allWidth}>
              <RatecardDisplay key={defaultChannel ? defaultChannel : 'no-channel'} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
